export default __webpack_public_path__ + "static/media/30 min.d33c8ccb.svg";